export class EstudoCientificoModel {
    especialidades: Array<string>;
    especialidade: string;
    search: string;
    estudos: Array<Estudo>
}

export class Estudo {
    id: string
    titulo: string;
    eNovo: boolean;
    descricao: string;
    tipo: string;
    tags: Array<string>;
    url_documento: string;
    upload_documento: string;
    tipo_documento: string;
    ja_visualizou: boolean;
}


// WEBPACK FOOTER //
// ./src/pages/estudos-cientificos/estudos-cientificos.modelview.ts